import React, { useState, useEffect } from 'react';
import api from '../../../config/axios';
import Swal from 'sweetalert2';
import { FaTimes, FaFilter, FaEye } from 'react-icons/fa';

import Paginacao from '../../../components/utils/paginacao';
import MeuVisagismoClienteDetalhesModal from './ClienteDetalhes';

const MeuVisagismoClientesModal = ({ usuario, onClose }) => {
    const [error, setError] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCliente, setSelectedCliente] = useState(null);
    const [clientes, setClientes] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 10;

    useEffect(() => {
        if (usuario && usuario.usuario_uuid) {
            fetchClientes(currentPage);
        }
    }, [usuario, currentPage]);

    const fetchClientes = async (page) => {
        try {
            Swal.fire({
                title: "Carregando...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                offset: page,
                limit: limit
            };

            const response = await api.get(`/meu-visagismo/usuario/${usuario.usuario_uuid}/clientes`, { params });

            const clientesProcessados = [];

            for (const cliente of response.data.clientes) {
                let nome = '';
                let dataNascimento = '';
                if (cliente.form_data &&
                    cliente.form_data.questions &&
                    cliente.form_data.questions.length > 0 &&
                    cliente.form_data.questions[0]) {

                    const questoes = cliente.form_data.questions[0];

                    for (const item of questoes) {
                        if (item.question === "Qual o seu nome?") {
                            nome = item.answer;
                        }
                        if (item.question === "Qual a sua data de nascimento?") {
                            dataNascimento = item.answer;
                        }
                    }
                }

                clientesProcessados.push({
                    ...cliente,
                    nome: nome,
                    data_nascimento: dataNascimento
                });
            }
            setClientes(clientesProcessados);
            setTotalPages(Math.ceil(response.data.total / limit) || 1);
            setError(null);
            Swal.close();
        } catch (error) {
            Swal.close();
            setError('Erro ao carregar os dados. Tente novamente mais tarde.');
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleVerDetalhes = (cliente) => {
        setSelectedCliente(cliente);
        setIsModalOpen(true);
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Clientes</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <h6 className="mt-2"><strong>Usuário:</strong> {usuario?.nome}</h6>
                        <h6 className="mt-2"><strong>E-mail:</strong> {usuario?.email}</h6>
                        {error ? (
                            <p className="error-message">{error}</p>
                        ) : (
                            <>
                                <div className="table-responsive mt-3">
                                    <table className="table table-striped">
                                        <thead className="table-custom-primary">
                                            <tr>
                                                <th className="text-nowrap">Nome</th>
                                                <th className="text-nowrap">E-mail</th>
                                                <th className="text-nowrap">Data de Nascimento</th>
                                                <th className="text-center">Detalhes</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {clientes.length > 0 ? (
                                                clientes.map((cliente) => (
                                                    <tr key={cliente.id}>
                                                        <td className="text-nowrap">{cliente.nome}</td>
                                                        <td className="text-nowrap">{cliente.email}</td>
                                                        <td className="text-nowrap">{cliente.data_nascimento}</td>
                                                        <td className="text-nowrap text-center">
                                                            <button
                                                                className="btn btn-custom-secondary btn-sm"
                                                                onClick={() => handleVerDetalhes(cliente)}
                                                                title="Ver Detalhes"
                                                            >
                                                                <FaEye />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center">Sem clientes cadastrados.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="d-flex justify-content-end mt-4">
                                    <Paginacao
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        onPageChange={handlePageChange}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                    <div className="modal-footer">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <MeuVisagismoClienteDetalhesModal
                    cliente={selectedCliente}
                    usuario={usuario}
                    onClose={() => setIsModalOpen(false)}
                />
            )}
        </div>
    );
};

export default MeuVisagismoClientesModal;
